import React, { createContext, useContext, useState, useEffect } from 'react';
import { startSessionTimer, clearSessionTimer } from '../services/api';

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    const stored = localStorage.getItem('user');
    if (stored) {
      try { setUser(JSON.parse(stored)); } catch { /* ignore */ }
    }
    // Start session timer for existing token on app load
    const existingToken = localStorage.getItem('token');
    if (existingToken) {
      startSessionTimer(existingToken);
    }
  }, []);

  const login = (tokenVal, userData) => {
    setToken(tokenVal);
    setUser(userData);
    localStorage.setItem('token', tokenVal);
    localStorage.setItem('user', JSON.stringify(userData));
    startSessionTimer(tokenVal);
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    clearSessionTimer();
  };

  const hasPermission = (key) => {
    if (!user) return false;
    if (user.is_admin) return true;
    return !!user.permissions?.[key];
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, hasPermission }}>
      {children}
    </AuthContext.Provider>
  );
};
